// src/pages/Profile/components/EmailNotificationsCard.jsx

import React from "react";
import { FaBell } from "react-icons/fa";

import { cn } from "../utils/profileUtils";

export default function EmailNotificationsCard({
  enabled,
  onToggle,
}) {
  return (
    <div className="mt-8 rounded-[2rem] border border-slate-200 bg-slate-50 p-5 dark:border-white/10 dark:bg-white/5">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="flex items-start gap-4">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-primary/10 text-primary">
            <FaBell />
          </div>

          <div>
            <h3 className="font-barlow text-xl font-bold text-slate-950 dark:text-white">
              Notifications par mail
            </h3>

            <p className="mt-2 text-sm leading-7 text-slate-500 dark:text-slate-400">
              Activez cette option pour recevoir certaines notifications
              importantes directement par email. Pensez à vérifier vos spams
              lors du premier envoi.
            </p>
          </div>
        </div>

        <button
          type="button"
          onClick={onToggle}
          className={cn(
            "relative inline-flex h-8 w-16 shrink-0 items-center rounded-full transition",
            enabled ? "bg-primary" : "bg-slate-300 dark:bg-slate-700"
          )}
          aria-pressed={!!enabled}
        >
          <span
            className={cn(
              "inline-block h-6 w-6 transform rounded-full bg-white shadow transition",
              enabled ? "translate-x-9" : "translate-x-1"
            )}
          />
        </button>
      </div>
    </div>
  );
}